import { IDatasource, IDatasourceReportFn } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IActiveVisit, IAppointment, IAppointmentRequest, IStudentInfo } from '../types/appointment_interfaces';

export interface IUpcomingAppointmentsDS {
  studentInfo: IStudentInfo;
  upcomingAppointments: IAppointment[];
  appointmentRequests: IAppointmentRequest[];
  pastAppointments: IAppointment[];
  activeVisits: IActiveVisit[];
}

export interface IAppointmentRequestObj {
  id: string;
  appointment_campaign: IAppointmentRequest;
}

export class UpcomingAppointmentsDatasource implements IDatasource {
  private _source: IUpcomingAppointmentsDS = {
    studentInfo: {} as IStudentInfo,
    upcomingAppointments: [],
    appointmentRequests: [],
    pastAppointments: [],
    activeVisits: []
  };

  constructor() {
    this.initialize();
  }

  initialize(): UpcomingAppointmentsDatasource {
    this._source = {
      studentInfo: {} as IStudentInfo,
      upcomingAppointments: [],
      appointmentRequests: [],
      pastAppointments: [],
      activeVisits: []
    };
    return this;
  }

  update(data: any) {
    this._source = data;
    return this;
  }

  write(raw: any): UpcomingAppointmentsDatasource {
    this._source = {
      studentInfo: raw.student,
      upcomingAppointments: _4.sortBy(raw.next_appointments, 'start_timestamp'),
      appointmentRequests: this._extractAppointmentRequests(raw),
      pastAppointments: _.sortByOrder(raw.past_appointments, 'start_timestamp', 'desc'),
      activeVisits: raw.activeVisits
    };
    return this;
  }

  private _extractAppointmentRequests(raw: any): IAppointmentRequest[] {
    return _4.sortBy(
      _4.filter(
        raw.appointment_invitations,
        (appointmentRequestObj: IAppointmentRequest) => appointmentRequestObj.remaining_appointments_for_student > 0
      ),
      'end_date'
    );
  }

  read(): IUpcomingAppointmentsDS {
    return this._source;
  }

  clear(): void {
    this.initialize();
  }

  report(fn: IDatasourceReportFn): any[] {
    return fn(this._source);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/datasources/upcoming_appointments_datasource.ts